import React, { useState } from "react";
import { useAuth } from "../../authProvider";
import { changePassword } from "../../../services/params";
import PasswordInput from "../../passwordInput";
import { showSuccessToaster } from "../../../Utils/toasters/success";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ChangePasswordForm() {
  const { currentUser } = useAuth();
  const { t } = useTranslation();

  const [loading, setloading] = useState(false);
  const [errors, setErrors] = useState({
    hasError: false,
    msg: "",
    oldPwd: "",
    newPwd: "",
    confirmPwd: "",
  });

  const [formData, setFormData] = useState({
    general: "",
    oldPwd: "",
    newPwd: "",
    confirmPwd: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Réinitialiser l'erreur au changement
    setErrors((prev) => ({
      ...prev,
      [name]: "",
      general: "",
    }));
  };

  const handleSubmit = async () => {
    setloading(true);
    let newErrors = {
      hasError: false,
      msg: "",
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",
    };
    let hasValidationError = false;

    if (!formData.oldPwd) {
      newErrors.oldPwd = t("Ce champ est requis");
      hasValidationError = true;
    }
    if (!formData.newPwd) {
      newErrors.newPwd = t("Ce champ est requis");
      hasValidationError = true;
    }
    if (!formData.confirmPwd) {
      newErrors.confirmPwd = t("Ce champ est requis");
      hasValidationError = true;
    }
    if (
      formData.newPwd &&
      formData.confirmPwd &&
      formData.newPwd !== formData.confirmPwd
    ) {
      newErrors.confirmPwd = t("Les mots de passe ne correspondent pas");
      hasValidationError = true;
    }

    if (hasValidationError) {
      setErrors(newErrors);
      setloading(false);
      return;
    }

    try {
      const res = await changePassword(
        currentUser.userId,
        formData.oldPwd,
        formData.newPwd
      );

      if (!res.success) {
        throw new Error(res.msg);
      }

      showSuccessToaster("Mot de passe changé avec succès");

      setFormData({
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
      });
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err.message ||
        "Une erreur s'est produite";

      if (message.includes("actuel")) {
        setErrors((prev) => ({ ...prev, oldPwd: message }));
      } else {
        setErrors((prev) => ({ ...prev, general: message }));
      }
    } finally {
      setloading(false);
    }
  };

  return (
    <>
      <div className="input-group">
        <label htmlFor="oldPwd">{t("Ancien mot de passe")}</label>
        <PasswordInput
          id="oldPwd"
          name="oldPwd"
          type="password"
          className="form-control"
          autoComplete="new-password"
          value={formData.oldPwd}
          onChange={handleInputChange}
        />
        {errors.oldPwd && (
          <small className="text-danger">{errors.oldPwd}</small>
        )}
      </div>

      <div className="input-group">
        <label htmlFor="newPwd">{t("Nouvelle mot de passe")}</label>
        <PasswordInput
          id="newPwd"
          name="newPwd"
          type="password"
          className="form-control"
          value={formData.newPwd}
          onChange={handleInputChange}
        />
        {errors.newPwd && (
          <small className="text-danger">{errors.newPwd}</small>
        )}
      </div>

      <div className="input-group">
        <label htmlFor="confirmPwd">{t("Confirmer mot de passe")}</label>
        <PasswordInput
          id="confirmPwd"
          name="confirmPwd"
          type="password"
          className="form-control"
          value={formData.confirmPwd}
          onChange={handleInputChange}
        />
        {errors.confirmPwd && (
          <small className="text-danger">{errors.confirmPwd}</small>
        )}
      </div>

      <br />
      <br />
      <div className="save-btn-container">
        <div className="error-msg d-flex justify-content-center">
          {errors.general && <p className="text-danger">{errors.general}</p>}
        </div>
        <button
          className="tab-btn-submit"
          onClick={handleSubmit}
          disabled={loading}
        >
          {t("Enregistrer")}
        </button>
      </div>
    </>
  );
}

export default ChangePasswordForm;
